import { color } from '@stockbit/ui';

const targetPriceType = {
  bearish: {
    text: 'Downside',
    color: color.sunsetOrange,
  },
  bullish: {
    text: 'Upside',
    color: color.primary,
  },
};

// eslint-disable-next-line import/prefer-default-export
export { targetPriceType };
